<template>
  <v-col>
    <points-table :customers="paid" :headers="headers" @refresh="getPaidCustomers">Paid Customers</points-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import pointsTable from "@/components/qantas/points-table";
export default {
  name: "PointsManagementReportEligible",
  components: {
    pointsTable
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        descending: false
      },
      paid: [],
      headers: [
        {
          text: "CSN",
          value: "csn",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Cust #",
          value: "custNo",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "File Set Number",
          value: "fileSetNumber",
          align: "left",
          sortable: true
        },
        {
          text: "Sequence Number",
          value: "sequenceNumber",
          align: "left",
          sortable: true
        },
        {
          text: "Points Paid",
          value: "pointsPaid",
          align: "left",
          sortable: true
        },
        {
          text: "Bonus Points Paid",
          value: "bonusPointsPaid",
          align: "left",
          sortable: true
        },
        {
          text: "Date Paid",
          value: "datePaid",
          align: "left",
          sortable: true
        },
        {
          text: "Return Result",
          value: "returnResult",
          align: "left",
          sortable: true
        },
        {
          text: "Reason (if rejected)",
          value: "rejectionReason",
          align: "left",
          sortable: true
        }
      ]
    };
  },
  mounted() {
    let vm = this;
    vm.getPaidCustomers();
  },
  methods: {
    ...mapActions("qantas", ["GetPaidCustomers"]),
    getPaidCustomers() {
      let vm = this;
      vm.GetPaidCustomers().then(data => {
        vm.paid = data;
      });
    }
  }
};
</script>